// @flow

import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Preview, { type BlogPreview } from "../components/BlogPreview"

type BlogProps = {
    data: {|
        site: {
            siteMetadata: {
                title: string,
                description: string,
            },
        },
        allMarkdownRemark: {
            nodes: Array<BlogPreview>,
        },
    |},
}

export default class Blog extends React.Component<BlogProps> {
    componentDidMount() {
        if (window.location.pathname === "/blog/")
            window.history.replaceState({ path: "/blog" }, "", "/blog")
    }

    render() {
        const { data } = this.props
        const { title, description } = data.site.siteMetadata
        const posts = data.allMarkdownRemark.nodes

        return (
            <Layout title={title} description={description}>
                <ol style={{ listStyle: `none` }}>
                    {posts.map((blogPreview: BlogPreview) => (
                        <Preview
                            {...blogPreview}
                            key={blogPreview.fields.slug}
                        />
                    ))}
                </ol>
            </Layout>
        )
    }
}

export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                title
                description
            }
        }
        allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
            nodes {
                excerpt
                fields {
                    slug
                }
                frontmatter {
                    date(formatString: "MMMM DD, YYYY")
                    title
                    description
                    image
                    author
                    tags
                }
            }
        }
    }
`
